<template>
  <div class="default-table items-table">
    <itemSave
      v-if="dialog.selected"
      v-model="dialog.selected"
      :id="dialog.selected.id"
      :dialog="dialog.save"
      @closed="onCloseSave"
    />
    <DataTable
      name="items"
      :items="data"
      :tablehdrs="tableheaders.items"
      :customdata="true"
      :sortdesc="false"
      itemkey="cod"
      sortby="cat_id"
      groupby="parent_cat_name"
    >
      <template v-slot:default="{ item }">
        <tr
          :key="item.id"
          @dblclick="editDialog(item)"
          class="table-row item-row"
          :class="{ 'inactive': !(item.active) || item.inactive_cat }"
        >
          <td>
            <strong>{{ item.id }}</strong>
          </td>
          <td>
            <Thumb :photo="item.photo" />
          </td>
          <td>{{ item.cod }}</td>
          <td>
            <v-chip color="light-green" dark>{{ (item.cat_name ? item.cat_name : lang.categories.new.no_one) }}</v-chip>
          </td>
          <td>
            <v-tooltip top v-if="!(item.active)">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" small class="inactiveSign">
                  <v-icon small>mdi-cancel</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.items.status.inactive }}</span>
            </v-tooltip>
            {{ item.title }}
          </td>
          <td>
            <v-chip v-if="item.description" color="blue darken-1" class="description" dark>{{ item.description }}</v-chip>
          </td>
          <td>{{ formatCurrency(item.price) }}</td>
          <td class="actions-col">
            <Actions :item="item" @edit="editDialog" />
          </td>
        </tr>
      </template>
      <template v-slot:mobile="{ item }">
        <tr
          :key="`mb-${item.id}`"
          @dblclick="editDialog(item)"
          class="mobile_row table-row item-row"
          :class="{ 'inactive': !(item.active) }"
        >
          <td class="mobile_col">
          <ul class="flex-content pl-2">
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.id}:`">{{ item.id }}</li>
            <li class="flex-item">
              <Thumb :photo="item.photo" />
            </li>
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.code}:`">{{ item.cod }}</li>
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.subcategory}:`">
              <v-chip color="light-green" dark>{{ (item.cat_name ? item.cat_name : lang.categories.new.no_one) }}</v-chip>
            </li>
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.title}:`">
              <v-tooltip top v-if="!(item.active)">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" small class="inactiveSign">
                    <v-icon small>mdi-cancel</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.items.status.inactive }}</span>
              </v-tooltip>
              {{ item.title }}
            </li>
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.description}:`">
              <v-chip v-if="item.description" color="blue darken-1" class="description" dark>{{ item.description }}</v-chip>
            </li>
            <li class="flex-item" :data-label="`${lang.items.datatable.headers.price}:`">{{ formatCurrency(item.price) }}</li>
            <li class="flex-item actions_row" :data-label="lang.items.datatable.headers.action">
              <Actions :item="item" @edit="editDialog" />
            </li>
          </ul>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Thumb from '@/components/catalog/items/templates/Thumb'
import Actions from '@/components/catalog/items/templates/Actions'
import itemSave from '@/components/catalog/items/Save'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import listDefaults from '@/mixins/defaults/list_subpage'

export default {
  components: { DataTable, Thumb, Actions, itemSave },
  mixins: [ appdata, utils, listDefaults ],
  data: () => ({
    pageName: 'items',
    default: { ...defaults.blank.item }
  }),
  computed: {
    data: {
      get: function () {
        console.log('custom_data', this.socketInfo.custom_data)
        if (this.socketInfo.custom_data && this.socketInfo.custom_data.catalog) {
          return this.socketInfo.custom_data.catalog
        }
        return []
      }
    }
  }
}
</script>

<style scoped src="@/components/catalog/items/styles/list.scss" lang="scss"></style>
